const modules = import.meta.glob([
  "~/pages/views/next-js/wrappers/MainNavigationWrapper.tsx",
  "~/pages/views/next-js/wrappers/FooterWrapper.tsx",
], { eager: true });

export default modules;
